import numeral from 'numeral';

import { Nullable } from '@/utils/types';
import { reduceAndSum } from '@/bundles/App/helpers/reduceAndSum';

// The stored ratio when the availability has one, otherwise its spaces per 1,000 SF of rentable size.
export const getAvailabilityParkingRatio = ({ ratio, covered, uncovered, buildingRentable }: {
  ratio: Nullable<number | string>;
  covered: Nullable<number | string>;
  uncovered: Nullable<number | string>;
  buildingRentable: Nullable<number | string>;
}): Nullable<string> => {
  if (ratio) {
    return `${ratio} / 1000`;
  }

  const totalSpaces = reduceAndSum([covered, uncovered]);

  if (!totalSpaces) {
    return null;
  }

  const rentable = Number(buildingRentable) / 1000;

  return rentable > 0 ? `${numeral(Number(totalSpaces) / rentable).format('0.00')} / 1000` : null;
};
